"use strict";

define('language/en-US',[], function () {
  return {
    "locale": "en-US",
    "phrases": {
      "Study.Details.Title": "Study Overview",
      "Study.Details.PreviousNavigation": "STUDY LIST",
      "Proposal.Finder.Info.Tooltip": "Edit the active submission to add more Researchers",
      "IGNORE EVERYTHING ABOVE THIS LINE": "THE ABOVE VALUES ARE FOR OLD IRB",
      "App.LogOut": "Log Out",
      "App.MyRoleLabel": "My Role:",
      "App.Notifications.Trigger.ARIALabel": "Notifications",
      "App.Nav.Dashboard": "Dashboard",
      "App.Nav.Studies": "Studies",
      "App.Nav.Submission": "Submissions",
      "App.Nav.Tasks": "Tasks",
      "App.Nav.Legacy": "Legacy Studies",
      "App.Nav.Meetings": "Meetings",
      "App.Nav.Settings": "Settings",
      "App.Nav.More": "More",
      "App.Nav.Templates": "Templates",
      "App.Nav.IRB": "Institutional Review Boards",
      "App.Nav.SubmissionTemplates": "Submissions",
      "App.Nav.ChecklistTemplates": "Checklists",
      "App.Nav.LetterTemplates": "Letters",
      "App.Nav.OrgApprovers": "Organizational Approvers",
      "App.Nav.AppSettings": "Application Settings",
      "App.Nav.LegacyUpload": "Legacy Upload",
      "App.Nav.Admin": "Admin",
      "App.Nav.Reporting": "Reporting",
      "App.Nav.Reporting.Beta": "Beta Reporting",
      "App.Nav.Reporting.Classic": "Classic Reporting",
      "App.Nav.Help": "Help",
      "App.Nav.OpenHelp": "Open Help",
      "App.Nav.ReleaseNotes": "Release Notes",
      "App.Nav.ProductSwitcher": "Products",
      "App.Nav.ProductSwitcher.HomePage.Text": "Home",
      "App.Paging.PageSize": "Page Size:",
      "App.Title": "Human Ethics - Cayuse Research Suite",
      "App.Logo.Link.Text": "Human Ethics Home",
      "Roles.Analyst": "Analyst",
      "Roles.Researcher": "Researcher",
      "Roles.Reviewer": "Reviewer",
      "Roles.OrgApprover": "Org Approver",
      "Roles.Admin": "Admin",
      "Assignments.PI": "Primary Reviewer",
      "Assignments.SecondaryReviewer": "Secondary Reviewer",
      "Assignments.Reviewer": "Reviewer",
      "Dashboard.Title": "Dashboard",
      "Dashboard.Buttons.InDraft": "In-Draft",
      "Dashboard.Buttons.OrgApproval": "Org Approval",
      "Dashboard.Buttons.PreReview": "Pre-Review",
      "Dashboard.Buttons.UnderReview": "Under Review",
      "Dashboard.Buttons.PostReview": "Post Review",
      "Dashboard.Buttons.FullBoardReviews": "<b>Full Board</b> Reviews",
      "Dashboard.Buttons.ExpeditedReviews": "<b>Expedited</b> Reviews",
      "Dashboard.Buttons.AdminReviews": "<b>Admin Level</b> Reviews",
      "Dashboard.Buttons.LimitedIRBReviews": "<b>Limited IRB</b> Reviews",
      "Dashboard.Buttons.ExemptReviews": "<b>Exempt</b> Reviews",
      "Dashboard.Buttons.AwaitingApproval": "Awaiting Authorization",
      "Dashboard.Buttons.OrgReviewed": "Org Reviewed",
      "Dashboard.Cards.MyStudies": "<b>My</b> Studies",
      "Dashboard.Cards.MyTasks": "<b>My</b> Tasks",
      "Dashboard.Cards.ActivityStream": "<b>Activity</b> Stream",
      "Dashboard.Cards.ApprovedStudies": "<b>Approved</b> Studies",
      "Dashboard.Cards.StudiesExpiringIn": "<b>Studies</b> Expiring in &nbsp;",
      "Dashboard.Cards.StudiesExpiringIn.Clean": "Studies Expiring in ",
      "Dashboard.Cards.ExpiredStudies": "<b>Expired</b> Studies",
      "Dashboard.Cards.SubmissionsWhereIAm": "<b>Submissions</b> where I am the &nbsp;",
      "Dashboard.Cards.SubmissionsWhereIAm.Clean": "Submissions where I am the ",
      "Dashboard.Cards.RecentOrgSubmissions": "<b>Recent Org</b> Submissions",
      "Dashboard.Cards.SubmissionsThatAre": "<b>Submissions</b> that are &nbsp;",
      "Dashboard.Cards.SubmissionsThatAre.Clean": "Submissions that are ",
      "Dashboard.Cards.Unassigned": "Unassigned",
      "Dashboard.Cards.AssignedToMe": "Assigned to me",
      "Dashboard.Cards.SubmissionsUnderReview": "<b>Submissions</b> under review",
      "Dashboard.Cards.SubUnderRev.Full": "Full Board Reviews",
      "Dashboard.Cards.SubUnderRev.Expedited": "Expedited Reviews",
      "Dashboard.Cards.SubUnderRev.Admin": "Admin Level Reviews",
      "Dashboard.Cards.SubUnderRev.Exempt": "Exempt Reviews",
      "Dashboard.Cards.SubUnderRev.Limited": "Limited IRB Reviews",
      "Dashboard.Cards.UpcomingReviews": "<b>Upcoming</b> Meetings",
      "Dashboard.Cards.MyMeetings": "<b>My</b> Meetings",
      "Dashboard.Cards.ViewMore": "View All",
      "Meetings.Calendar.BoardDropdown.ARIALabel": "Select a board",
      "Meetings.Calendar.Title": "Meetings",
      "Meetings.CalendarMenu.MonthView.ARIALabel": "View currently selected month",
      "Meetings.CalendarMenu.WeekView.ARIALabel": "View currently selected week",
      "Meetings.CalendarMenu.ListView.ARIALabel": "View meetings for currently selected month",
      "Meetings.Details.Title": "Meeting Details",
      "Meetings.Details.BoardNav.PreviousButton.Text": "Previous Board Meeting",
      "Meetings.Details.BoardNav.NextButton.Text": "Next Board Meeting",
      "Meetings.Details.EditButton.ARIALabel": "edit this meeting",
      "Meetings.Details.DeleteButton.ARIALabel": "delete this meeting",
      "Meetings.Details.Tabs.ARIALabel": "Additional Meeting Information",
      "Meetings.Details.Tabs.Attendees.Title": "Attendees",
      "Meetings.Details.Tabs.Attendees.AddButton.ARIALabel": "Add an attendee",
      "Meetings.Details.Tabs.Attendees.UndoButton.ARIALabel": "Undo removing an attendee",
      "Meetings.Details.Tabs.Attachments.Title": "Attachments",
      "Meetings.Details.Tabs.Attachments.AddButton.ARIALabel": "Add an attachment",
      "Meetings.Details.Tabs.FullBoardReviews.Title": "Full Board Reviews",
      "Meetings.Details.Tabs.FullBoardReviews.AddButton.ARIALabel": "Add a submission",
      "Meetings.Details.Tabs.FullBoardReviews.UndoButton.ARIALabel": "Undo removing a submission",
      "Meetings.Details.Tabs.FullExpeditedReviews.Title": "Full Expedited Reviews",
      "Meetings.Details.Tabs.ExpeditedReviews.Title": "Expedited Reviews",
      "Meetings.Details.Tabs.AdminReviews.Title": "Admin Level Reviews",
      "Meetings.Details.Tabs.ExemptReviews.Title": "Exempt Reviews",
      "Meetings.Details.Tabs.Closures.Title": "Closures",
      "Meetings.PrevNextButtons.ARIALabel.Prefix": "Go to ",
      "Meetings.TodayButton.ARIALabel.Prefix": "Go to today, ",
      "StudiesPage.Button.PDF.ARIALabel": "Create a PDF from this page",
      "StudiesPage.Button.Delete.ARIALabel": "Delete this study",
      "StudiesPage.Button.Link.ARIALabel": "Link a proposal to this study",
      "StudiesPage.Details.Title": "Study Details",
      "StudiesPage.Details.TopTabs.ARIALabel": "Study Details and Submissions",
      "StudiesPage.Details.BottomTabs.ARIALabel": "Additional Study Information",
      "StudiesPage.Details.TopSegmentHeader": "Overview",
      "StudiesPage.Details.BottomSegmentHeader": "Contacts and Attachments",
      "StudiesPage.FilterBy.Active": "Active",
      "StudiesPage.FilterBy.Active.ARIALabel": "View a list of active studies",
      "StudiesPage.FilterBy.Archive": "Archive",
      "StudiesPage.FilterBy.Archive.ARIALabel": "View a list of archived studies",
      "StudiesPage.Submissions.TableHeaderText": "Submission Template Types",
      "StudiesPage.TableHeader.Active": "Active Studies",
      "StudiesPage.TableHeader.Archive": "Archived Studies",
      "StudiesPage.Title": "Studies",
      "StudiesPage.VSFields.Label": "IRB#",
      "StudiesPage.VSFields.PI": "PI",
      "StudiesPage.VSFields.Status": "Status",
      "StudiesPage.VSFields.Title": "Title",
      "StudiesPage.VSFields.StudyTitle": "Study Title",
      "StudiesPage.VSFields.ExpiringWithin": "Expiring Within",
      "StudiesPage.VSFields.AdminCheckInDate": "Admin Check-in Date",
      "StudiesPage.VSFields.All": "All",
      "StudiesPage.CreateStudyButton": "New Study",
      "StudiesPage.CreateStudyButton.ARIALabel": "Create a new study",
      "StudiesPage.CreateStudy.TitleLabel": "Study Title",
      "StudiesPage.Columns.Label": "IRB#",
      "StudiesPage.Columns.Title": "Study",
      "StudiesPage.Columns.Status": "Status",
      "StudiesPage.Columns.PI": "PI",
      "StudiesPage.Columns.ExpDate": "Exp Date",
      "StudiesPage.Columns.ActivityDate": "Last Activity",
      "StudiesPage.Columns.AdminCheckinDate": "Admin Check-in Date",
      "StudiesPage.Columns.CreateDate": "Create Date",
      "StudiesPage.Columns.StudyTitle": "Study Title",
      "StudiesPage.NoStudies": "No Studies",
      "Submissions.Button.Checklist.ARIALabel": "View checklist for this submission",
      "Submissions.Button.Delete.ARIALabel": "Delete this submission",
      "Submissions.Button.PDF.ARIALabel": "Create a PDF from this page",
      "Submissions.Button.View.ARIALabel.Prefix": "View",
      "Submissions.Button.Edit.ARIALabel.Prefix": "Edit",
      "Submissions.Button.Review.ARIALabel.Prefix": "Review",
      "Submissions.Button.ViewEditReview.ARIALabel.Suffix": " this submission",
      "Submissions.Details.Approvals.Title": "Approvals",
      "Submissions.Details.Approvals.ResearchTeam.Title": "Research Team",
      "Submissions.Details.Approvals.OrgApprovers.Title": "Org Approvers",
      "Submissions.Details.Attachments.Title": "Attachments",
      "Submissions.Details.Decisions.Title": "Decisions",
      "Submissions.Details.Decisions.Digest.Title": "Digest",
      "Submissions.Details.Decisions.History.Title": "History",
      "Submissions.Details.Letters.Title": "Letters",
      "Submissions.Details.Meetings.Title": "Meetings",
      "Submissions.Details.TaskHistory.Title": "Task History",
      "Submissions.Details.Tabs.ARIALabel": "Additional Submission Information",
      "Submissions.Details.Title": "Submission Details",
      "Submissions.Edit.Actions.PreviousButton.ARIALabel": "go to previous section",
      "Submissions.Edit.Actions.NextButton.ARIALabel": "go to next section",
      "Submissions.Edit.HelpText.ARIALabel.Prefix": "help for question ",
      "Submissions.Edit.HelpText.ARIALabel.Generic": "help for this question",
      "SubmissionDetails.RequiredTasks.ARIALabel": "Required Tasks",
      "SubmissionDetails.Steps.1.Title": "In-Draft",
      "SubmissionDetails.Steps.2.Title": "Awaiting Authorization",
      "SubmissionDetails.Steps.3.Title": "Pre-Review",
      "SubmissionDetails.Steps.4.Title": "Under-Review",
      "SubmissionDetails.Steps.1.Description": "Submission is with researchers",
      "SubmissionDetails.Steps.2.Description": "Submission is awaiting certification or approval",
      "SubmissionDetails.Steps.3.Description": "Submission is being prepared for review",
      "SubmissionDetails.Steps.4.Description": "Submission is with reviewers",
      "SubmissionsPage.Title": "Submissions",
      "SubmissionPage.VSFields.Analyst": "Analyst",
      "SubmissionPage.VSFields.PrimaryReviewer": "Primary Reviewer",
      "SubmissionPage.VSFields.Decision": "Decision",
      "SubmissionPage.VSFields.Status": "Status",
      "SubmissionPage.VSFields.PI": "PI",
      "SubmissionPage.VSFields.ReviewType": "Review Type",
      "SubmissionPage.VSFields.SubmissionType": "Submission Type",
      "SubmissionPage.VSFields.SubmissionDate": "Submission Date",
      "SubmissionPage.VSFields.StudyAdminCheckInDate": "Study Admin Check-in Date",
      "SubmissionPage.VSFields.ProcessEndDate": "Process End Date",
      "SubmissionPage.VSFields.StudyExpirationDate": "Study Expiration Date",
      "SubmissionPage.VSFields.StudyTitle": "Title",
      "SubmissionPage.VSFields.MyAssignment": "My Assignment",
      "SubmissionPage.VSFields.StudyLabel": "IRB#",
      "SubmissionPage.VSFields.All": "All",
      "SubmissionPage.VSFields.Text": "Text",
      "SubmissionPage.Pending": "Pending",
      "SubmissionPage.Columns.StudyLabel": "IRB#",
      "SubmissionPage.Columns.StudyTitle": "Submission",
      "SubmissionPage.Columns.Status": "Status",
      "SubmissionPage.Columns.ReviewType": "Review Type",
      "SubmissionPage.Columns.PI": "PI",
      "SubmissionPage.Columns.Analyst": "Analyst",
      "SubmissionPage.Columns.Assignment": "My Assignment",
      "SubmissionPage.Columns.MeetingDate": "Meeting Date",
      "SubmissionPage.Columns.ActivityDate": "Last Activity",
      "SubmissionPage.Columns.DecisionResultDate": "Decision",
      "SubmissionsPage.NoSubmissions": "No Submissions",
      "TasksPage.Title": "Tasks",
      "TasksPage.VSFields.StudyTitle": "Title",
      "TasksPage.VSFields.StudyLabel": "IRB#",
      "TasksPage.VSFields.TaskDisplayName": "Task",
      "TasksPage.VSFields.All": "All",
      "TasksPage.Columns.StudyLabel": "IRB#",
      "TasksPage.Columns.StudyTitle": "Task",
      "TasksPage.Columns.Assignment": "My Assignment",
      "TasksPage.Columns.TaskBeginDate": "Tasked Date",
      "TasksPage.NoTasks": "All Tasks Complete",
      "ReportingPage.FilterBy.System.Report": "systemReports",
      "ReportingPage.FilterBy.Custom.Report": "customerReports",
      "ReportingPage.System.Report.Toggle.Name": "System Reports",
      "ReportingPage.System.Report.Toggle.ARIALabel": "System Generated Reports",
      "ReportingPage.System.Report.Table.Header.Name": "System Generated Reports",
      "ReportingPage.System.Report.Columns.Name": "System Report Name",
      "ReportingPage.System.Report.Columns.Author": "Author",
      "ReportingPage.System.Report.Columns.LastRunDate": "Last Run",
      "ReportingPage.Title": "Reporting",
      "ReportingPage.RowAction.Run": "Run",
      "ReportingPage.RowAction.Edit": "Edit",
      "ReportingPage.RowAction.Delete": "Delete",
      "ReportingPage.CreateReportButton": "New Report",
      "ReportingPage.CreateReportButton.ARIALabel": "Create a new report",
      "ReportingPage.NoReports": "No Reports",
      "ReportingPage.Custom.Report.Toggle.Name": "Customer Reports",
      "ReportingPage.Custom.Report.Toggle.ARIALabel": "Customer Generated Reports",
      "ReportingPage.Custom.Report.Table.Header.Name": "Customer Generated Reports",
      "ReportingPage.Columns.Name": "Customer Report Name",
      "ReportingPage.Columns.Author": "Author",
      "ReportingPage.Columns.CreateDate": "Date Created",
      "ReportingPage.Columns.ModifyDate": "Date Modified",
      "ReportingPage.Columns.LastRunDate": "Last Run",
      "ReportingPage.Details.Title": "Reporting Details",
      "ReportingPage.Details.Actions.Delete.Text": "Delete",
      "ReportingPage.Details.Actions.Delete.ARIALabel": "Delete this report",
      "ReportingPage.Details.Actions.Export.Text": "Export",
      "ReportingPage.Details.Actions.Export.ARIALabel": "Export this report",
      "ReportingPage.Details.Actions.Preview.Text": "Preview",
      "ReportingPage.Details.Actions.Preview.ARIALabel": "Preview this report",
      "ReportingPage.Details.Actions.Save.Text": "Save",
      "ReportingPage.Details.Actions.Save.ARIALabel": "Save this report",
      "ReportingPage.Details.ColumnOptions.ARIALabel": "Report columns",
      "ReportingPage.Details.ReportOptions.Title": "Report Options",
      "ReportingPage.Details.ReportFields.Title": "Report Fields",
      "ReportingPage.Details.ColumnOptions.AddButton.ARIALabel.Prefix": "Add column header ",
      "LetterTemplatesList.Title": "Letter Templates",
      "LetterTemplatesList.Column.Name": "Name",
      "LetterTemplatesList.Column.Active": "Active",
      "LetterTemplatesList.Column.SubmissionType": "Submission Type",
      "LetterTemplatesList.Column.LastModifiedDate": "Last Modified",
      "LetterTemplatesList.Empty": "You have no Letter Templates",
      "LetterTemplateList.NewButton": "New Template",
      "LetterTemplateDetail.Title": "Letter Template Details",
      "LetterTemplateDetail.Label.Name": "Name",
      "LetterTemplateDetail.Label.SubmissionType": "Submission Type",
      "LetterTemplateDetail.Label.Active": "Active",
      "LetterTemplateDetail.Label.Inactive": "Inactive",
      "LetterTemplateDetail.Placeholder.Content": "Letter Template Content",
      "LetterTemplateDetail.SaveButton": "Save",
      "LetterTemplateDetail.DeleteButton": "Delete",
      "LetterList.Title": "Letters",
      "LetterList.Column.Name": "Name",
      "LetterList.Column.Active": "Active",
      "LetterList.Column.SubmissionType": "Submission Type",
      "LetterList.Column.LastModifiedDate": "Last Modified",
      "LetterList.Empty": "You have no Letters",
      "LetterList.NewButton": "New Letter",
      "LetterDetail.Title": "Letter Template Details",
      "LetterDetail.Label.Name": "Title",
      "LetterDetail.Placeholder.Content": "Letter Content",
      "LetterDetail.SaveButton": "Save",
      "LetterDetail.DeleteButton": "Delete",
      "Pagination.ARIALabel": "Pagination",
      "LegacyUpload.Title": "Legacy Upload",
      "LegacyUpload.Results.Title": "Results",
      "LegacyUpload.NextButton.ARIALabel": "Next Step",
      "LegacyUpload.PreviousButton.ARIALabel": "Previous Step",
      "LegacyUpload.ResultsCard.Button.Show.Prefix": "View records that ",
      "LegacyUpload.ResultsCard.Button.Hide.Prefix": "Hide records that ",
      "LegacuUpload.ResultsCard.Failed.Suffix": "will fail to be created.",
      "LegacuUpload.ResultsCard.Updated.Suffix": "will be successfully updated.",
      "LegacuUpload.ResultsCard.Created.Suffix": "will be successfully created.",
      "Application.Settings.Title": "Application Settings",
      "Application.Settings.Navigation.ARIALabel": "Settings",
      "Settings.Templates.List.ARIALabel": "templates, grouped by published versus non-published",
      "Settings.ReviewBoards.List.Title": "Review Boards",
      "Settings.ReviewBoards.Details.Title": "Review Board Details",
      "Settings.OrgApprovers.List.Title": "Org Approvers",
      "Settings.MessageTemplates.List.Tabs.ARIALabel": "Emails and Notifications",
      "Settings.MessageTemplates.List.Title": "Message Templates",
      "Settings.MessageTemplates.Details.Title": "Message Template Details",
      "FormWrapper.Buttons.Confirm": "Confirm",
      "FormWrapper.Buttons.Close": "Close"
    }
  };
});

